exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SectionTitle_sectionTitle__1LdcO {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  position: relative;\n  padding-right: 1.6rem;\n  font-size: 1.25rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .SectionTitle_sectionTitle__1LdcO .SectionTitle_icon__3eSg6 {\n    display: -webkit-flex;\n    display: flex;\n    position: absolute;\n    right: 0; }\n", ""]);

// exports
exports.locals = {
	"sectionTitle": "SectionTitle_sectionTitle__1LdcO",
	"icon": "SectionTitle_icon__3eSg6"
};